import { createTheme } from "@mui/material/styles";

import { breakpointsAndComponentsTheme as theme } from "./breakpointsAndComponentsTheme";
import { externalFonts } from "./utils/mappers";

export const fontsTheme = createTheme(theme, {
  typography: {
    ...externalFonts(),
    h0: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 400,
      fontSize: 288,
      lineHeight: "338px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 124,
        lineHeight: "120px",
      },
      [theme.breakpoints.down("desktopXl")]: {
        fontSize: 150,
        lineHeight: "120px",
      },
    },
    h1: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 124,
      lineHeight: "145px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 48,
        lineHeight: "56px",
      },
    },
    h2: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 96,
      lineHeight: "112px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 48,
        lineHeight: "56px",
      },
    },
    h3: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 72,
      lineHeight: "84px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 36,
        lineHeight: "42px",
      },
    },
    h4: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 48,
      lineHeight: "56px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 24,
        lineHeight: "28px",
      },
    },
    h5: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 36,
      lineHeight: "42px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 20,
        lineHeight: "23px",
      },
    },
    subtitle: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 24,
      lineHeight: "28px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 18,
        lineHeight: "21px",
      },
    },
    subtitleCode: {
      fontFamily: "Roboto Mono, monospace",
      fontWeight: 500,
      fontSize: 24,
      lineHeight: "32px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 18,
        lineHeight: "24px",
      },
    },
    body: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontSize: 18,
      lineHeight: "23px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 16,
        lineHeight: "21px",
      },
    },
    bodyMedium: {
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 500,
      fontSize: 18,
      lineHeight: "21px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 16,
        lineHeight: "21px",
      },
    },
    caption: {
      textTransform: "uppercase",
      fontFamily: "Work Sans, Arial, sans-serif",
      fontWeight: 600,
      fontSize: 18,
      lineHeight: "21px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 16,
        lineHeight: "19px",
      },
    },
    navigation1: {
      fontFamily: `'Roboto Mono', monospace`,
      letterSpacing: "0.1em",
      fontWeight: 500,
      fontSize: 18,
      lineHeight: "24px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 16,
        lineHeight: "21px",
      },
    },
    navigation2: {
      fontFamily: `'Roboto Mono', monospace`,
      letterSpacing: "0.1em",
      fontWeight: 500,
      fontSize: 14,
      lineHeight: "18px",
    },
    code1: {
      fontFamily: `'Roboto Mono', monospace`,
      fontWeight: 400,
      fontSize: 18,
      lineHeight: "24px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 16,
        lineHeight: "21px",
      },
    },
    code2: {
      fontFamily: `'Roboto Mono', monospace`,
      fontWeight: 500,
      fontSize: 18,
      lineHeight: "24px",
      [theme.breakpoints.down("desktop")]: {
        fontSize: 16,
        lineHeight: "21px",
      },
    },
  },
});
